import React, {
  useRef,
  useEffect,
  useState,
  forwardRef,
  useImperativeHandle,
  useMemo,
} from "react";
import {callApi, fnGetDataSet} from "@shared/api/restApi";
import { getInitFormData } from "@shared/utils/CommonUtils";
import { global } from "@shared/libs/Global";
import { fnSave } from "@shared/api/restApi";
import { menuInfo } from "@shared/type/CommonType";
import { showDialog } from "@widgets/CommonDialog";
import SnTab from "@shared/components/SnTab";
import SnGrid from "@shared/components/GridV2/SnGrid";
import SnTabHeader from "@shared/components/SnTabHeader";
import SnButton from "@shared/components/SnButton";
import SnResizable from "@shared/components/SnResizable";
import usePanelSizes from "@shared/hooks/usePanelSizes";

interface Props {
  Menuprops: menuInfo;
}

interface RowData {
  KeyField?: string;

  [key: string]: any;
}

const SN_MAS_SET_REG_004 = forwardRef(({ Menuprops }: Props, ref) => {
  const { userInfo } = global();
  const [selectedTab, setSelectedTab] = useState("1");

  //#region 탭별 좌/우 그리드 폭
  // 탭마다 좌측 그리드 폭을 따로 저장한다(seq n = defaultSize 의 n번째 키).
  // 우측 그리드는 남는 폭을 채우므로 별도 키가 필요 없다.
  const cd_menu = Menuprops.cd_menu || "SN_MAS_SET_REG_004";
  const defaultSize = {
    panelTab1: "40%",
    panelTab2: "40%",
    panelTab3: "40%",
    panelTab4: "40%",
    panelTab5: "40%",
    panelTab6: "40%",
    panelTab7: "40%",
  };
  const [sizes, onResizeStop] = usePanelSizes(cd_menu, defaultSize);
  //#endregion
  const gridRefs = useRef<{ [key: string]: React.RefObject<any> }>({
    grid1: React.createRef(),
    grid2: React.createRef(),
    grid3: React.createRef(),
    grid4: React.createRef(),
    grid5: React.createRef(),
    grid6: React.createRef(),
    grid7: React.createRef(),
    grid8: React.createRef(),
    grid9: React.createRef(),
    grid10: React.createRef(),
    grid11: React.createRef(),
    grid12: React.createRef(),
    grid13: React.createRef(),
    grid14: React.createRef(),
  });

  //매출
  const [columns, setColums] = useState<any>({
    grid1: [],
    grid2: [],
    grid3: [],
    grid4: [],
    grid5: [],
    grid6: [],
    grid7: [],
    grid8: [],
    grid9: [],
    grid10: [],
    grid11: [],
    grid12: [],
    grid13: [],
    grid14: [],
  });
  const [dataSources, setDataSources] = useState<any>({
    grid1: [],
    grid2: [],
    grid3: [],
    grid4: [],
    grid5: [],
    grid6: [],
    grid7: [],
    grid8: [],
    grid9: [],
    grid10: [],
    grid11: [],
    grid12: [],
    grid13: [],
    grid14: [],
  });

  const [doAddRow, setDoAddRow] = useState<boolean>(true);
  const [isLoading, setIsLoading] = useState(false);
  const [gridFocus, setGridFocus] = useState(false);

  useEffect(() => {
    const fetchform = async () => {
      try {
        const rtn: any = await getInitFormData();
        setColums({
          grid1: rtn.grid.grid1,
          grid2: rtn.grid.grid2,
          grid3: rtn.grid.grid3,
          grid4: rtn.grid.grid4,
          grid5: rtn.grid.grid5,
          grid6: rtn.grid.grid6,
          grid7: rtn.grid.grid7,
          grid8: rtn.grid.grid8,
          grid9: rtn.grid.grid9,
          grid10: rtn.grid.grid10,
          grid11: rtn.grid.grid11,
          grid12: rtn.grid.grid12,
          grid13: rtn.grid.grid13,
          grid14: rtn.grid.grid14,
        });
      } catch (error) {}
    };
    fetchform();
  }, []);

  // useEffect(() => {
  //   if (selectedTab === "1") gridRef1.current?.selectAndFocusRow(0);
  //   else if (selectedTab === "2") gridRef3.current?.selectAndFocusRow(0);
  //   else if (selectedTab === "3") gridRef5.current?.selectAndFocusRow(0);
  //   else if (selectedTab === "4") gridRef7.current?.selectAndFocusRow(0);
  //   else if (selectedTab === "5") gridRef9.current?.selectAndFocusRow(0);
  //   else if (selectedTab === "6") gridRef11.current?.selectAndFocusRow(0);
  //   else if (selectedTab === "7") gridRef13.current?.selectAndFocusRow(0);
  //   setGridFocus(false);
  // }, [gridFocus]);

  const tabGridMap: Record<string, string[]> = {
    "1": ["grid1", "grid2"],
    "2": ["grid3", "grid4"],
    "3": ["grid5", "grid6"],
    "4": ["grid7", "grid8"],
    "5": ["grid9", "grid10"],
    "6": ["grid11", "grid12"],
    "7": ["grid13", "grid14"],
  };

  const onSearch = async (tab = selectedTab) => {
    try {
      const currentGrids = tabGridMap[selectedTab] || [];
      const targetGrids = tabGridMap[tab] || [];

      const hasModified = currentGrids.some((gridKey) => {
        const grid = gridRefs.current[gridKey]?.current;
        if (!grid) return false;

        const change = grid.getChange();
        return change.modifiedRowcount > 0;
      });

      if (hasModified) {
        const confirm = await showDialog(
          "confirm",
          "수정된 내용이 있습니다. 저장하시겠습니까?"
        );

        if (confirm) {
          const isSaved: any = await onSave();
          if (!isSaved) return;
        } else {
          resetGridData(selectedTab);
        }
      }

      const params = {
        id: "sn_mas_set_reg_004_01",
        params: { cd_firm: userInfo.cd_firm, tp_fin: tab },
      };

      resetGridData(tab);

      const data: any = await fnGetDataSet(params);
      const [headerGrid, detailGrid] = targetGrids;
      setDataSources((prev: any) => ({
        ...prev,
        [headerGrid]: data[0] || [],
        [detailGrid]: data[1] || [],
      }));

      setDoAddRow(true);
    } catch (error: any) {}
  };
  const stopEditingForGrids = () => {
    gridRefs.current["grid1"].current.stopEditing();
    gridRefs.current["grid2"].current.stopEditing();
    gridRefs.current["grid3"].current.stopEditing();
    gridRefs.current["grid4"].current.stopEditing();
    gridRefs.current["grid5"].current.stopEditing();
    gridRefs.current["grid6"].current.stopEditing();
    gridRefs.current["grid7"].current.stopEditing();
    gridRefs.current["grid8"].current.stopEditing();
    gridRefs.current["grid9"].current.stopEditing();
    gridRefs.current["grid10"].current.stopEditing();
    gridRefs.current["grid11"].current.stopEditing();
    gridRefs.current["grid12"].current.stopEditing();
    gridRefs.current["grid13"].current.stopEditing();
    gridRefs.current["grid14"].current.stopEditing();
  };

  const onSave = async () => {
    try {
      stopEditingForGrids();

      let SaveData: any = {};
      if (selectedTab === "1") {
        if (!gridRefs.current["grid1"].current.requiredValuesCheck()) {
          return;
        }
        if (!gridRefs.current["grid1"].current.requiredValuesCheck()) {
          return;
        }

        const grid1Changes = gridRefs.current["grid1"].current.getChange();
        const grid2Changes = gridRefs.current["grid2"].current.getChange();

        SaveData = {
          mas_fintypeh: grid1Changes,
          mas_fintypel: grid2Changes,
        };
      } else if (selectedTab === "2") {
        if (!gridRefs.current["grid3"].current.requiredValuesCheck()) {
          return;
        }
        if (!gridRefs.current["grid4"].current.requiredValuesCheck()) {
          return;
        }

        const grid3Changes = gridRefs.current["grid3"].current.getChange();
        const grid4Changes = gridRefs.current["grid4"].current.getChange();

        SaveData = {
          mas_fintypeh: grid3Changes,
          mas_fintypel: grid4Changes,
        };
      } else if (selectedTab === "3") {
        if (!gridRefs.current["grid5"].current.requiredValuesCheck()) {
          return;
        }
        if (!gridRefs.current["grid6"].current.requiredValuesCheck()) {
          return;
        }

        const grid5Changes = gridRefs.current["grid5"].current.getChange();
        const grid6Changes = gridRefs.current["grid6"].current.getChange();

        SaveData = {
          mas_fintypeh: grid5Changes,
          mas_fintypel: grid6Changes,
        };
      } else if (selectedTab === "4") {
        if (!gridRefs.current["grid7"].current.requiredValuesCheck()) {
          return;
        }
        if (!gridRefs.current["grid8"].current.requiredValuesCheck()) {
          return;
        }

        const grid7Changes = gridRefs.current["grid7"].current.getChange();
        const grid8Changes = gridRefs.current["grid8"].current.getChange();

        SaveData = {
          mas_fintypeh: grid7Changes,
          mas_fintypel: grid8Changes,
        };
      } else if (selectedTab === "5") {
        if (!gridRefs.current["grid9"].current.requiredValuesCheck()) {
          return;
        }
        if (!gridRefs.current["grid10"].current.requiredValuesCheck()) {
          return;
        }

        const grid9Changes = gridRefs.current["grid9"].current.getChange();
        const grid10Changes = gridRefs.current["grid10"].current.getChange();

        SaveData = {
          mas_fintypeh: grid9Changes,
          mas_fintypel: grid10Changes,
        };
      } else if (selectedTab === "6") {
        if (!gridRefs.current["grid11"].current.requiredValuesCheck()) {
          return;
        }
        if (!gridRefs.current["grid12"].current.requiredValuesCheck()) {
          return;
        }

        const grid11Changes = gridRefs.current["grid11"].current.getChange();
        const grid12Changes = gridRefs.current["grid12"].current.getChange();

        SaveData = {
          mas_fintypeh: grid11Changes,
          mas_fintypel: grid12Changes,
        };
      } else if (selectedTab === "7") {
        if (!gridRefs.current["grid13"].current.requiredValuesCheck()) {
          return;
        }
        if (!gridRefs.current["grid14"].current.requiredValuesCheck()) {
          return;
        }

        const grid13Changes = gridRefs.current["grid13"].current.getChange();
        const grid14Changes = gridRefs.current["grid14"].current.getChange();

        SaveData = {
          mas_fintypeh: grid13Changes,
          mas_fintypel: grid14Changes,
        };
      }

      if (
        (!SaveData.mas_fintypeh ||
          SaveData.mas_fintypeh.modifiedRowcount === 0) &&
        (!SaveData.mas_fintypel || SaveData.mas_fintypel.modifiedRowcount === 0)
      ) {
        await showDialog("error", "변경된 내용이 없습니다.");
        return;
      }

      const ok = await fnSave("SN_MAS_SET_REG_004_SAVE_01", SaveData);
      if (!ok) return false;
      setDoAddRow(true);
      resetGridData();
      return true;
    } catch (error: any) {
      setDoAddRow(false);
      return false;
    }
  };

  const resetGridData = (tab = selectedTab) =>
    tabGridMap[tab]?.forEach((gridKey) =>
      gridRefs.current[gridKey].current?.resetUpdate()
    );

  const updateDataSource = async (tabNumber: string, gridRef: any) => {
    try {
      if (!doAddRow) return;
      const params = {
        id: "sn_mas_set_reg_004_01",
        params: { cd_firm: userInfo.cd_firm, tp_fin: tabNumber },
      };

      const data: any = await fnGetDataSet(params);

      if (
        !data ||
        data.length < 2 ||
        !Array.isArray(data[1]) ||
        data[1].length === 0
      )
        return;

      data[1].map((result: any) => {
        const newRowL = {};
        if (tabNumber === "1") {
          const addedNode = onAddRow();
          setData(gridRef, result, addedNode);
        } else if (tabNumber === "2") {
          const addedNode = onAddRow();
          setData(gridRef, result, addedNode);
        } else if (tabNumber === "3") {
          const addedNode = onAddRow();
          setData(gridRef, result, addedNode);
        } else if (tabNumber === "4") {
          const addedNode = onAddRow();
          setData(gridRef, result, addedNode);
        } else if (tabNumber === "5") {
          const addedNode = onAddRow();
          setData(gridRef, result, addedNode);
        } else if (tabNumber === "6") {
          const addedNode = onAddRow();
          setData(gridRef, result, addedNode);
        } else if (tabNumber === "7") {
          const addedNode = onAddRow();
          setData(gridRef, result, addedNode);
        }
      });
    } catch (error) {}
  };

  const setData = (gridRef: any, result: any, addedNode: any) => {
    try {
      gridRef.setValueImmediately(addedNode, "no_line", result.no_line);
      gridRef.setValueImmediately(addedNode, "nm_acct", result.nm_acct);
      gridRef.setValueImmediately(addedNode, "tp_acct", result.tp_acct);
    } catch (error) {}
  };

  const onAddRow = () => {
    try {
      if (selectedTab === "1") {
        return gridRefs.current["grid2"].current?.addRow({});
      } else if (selectedTab === "2") {
        return gridRefs.current["grid4"].current?.addRow({});
      } else if (selectedTab === "3") {
        return gridRefs.current["grid6"].current?.addRow({});
      } else if (selectedTab === "4") {
        return gridRefs.current["grid8"].current?.addRow({});
      } else if (selectedTab === "5") {
        return gridRefs.current["grid10"].current?.addRow({});
      } else if (selectedTab === "6") {
        return gridRefs.current["grid12"].current?.addRow({});
      } else if (selectedTab === "7") {
        return gridRefs.current["grid14"].current?.addRow({});
      }
    } catch (error: any) {}
  };

  const onBeforeAddRowL = () => {
    try {
      if (selectedTab === "1") {
        const selectedRows = gridRefs.current["grid1"].current.focusedRowNode();
        return {
          cd_firm: userInfo.cd_firm,
          cd_fin: selectedRows.data?.cd_fin,
          tp_fin: "1",
        };
      } else if (selectedTab === "2") {
        const selectedRows = gridRefs.current["grid3"].current.focusedRowNode();
        return {
          cd_firm: userInfo.cd_firm,
          cd_fin: selectedRows.data?.cd_fin,
          tp_fin: "2",
        };
      } else if (selectedTab === "3") {
        const selectedRows = gridRefs.current["grid5"].current.focusedRowNode();
        return {
          cd_firm: userInfo.cd_firm,
          cd_fin: selectedRows.data?.cd_fin,
          tp_fin: "3",
        };
      } else if (selectedTab === "4") {
        const selectedRows = gridRefs.current["grid7"].current.focusedRowNode();
        return {
          cd_firm: userInfo.cd_firm,
          cd_fin: selectedRows.data?.cd_fin,
          tp_fin: "4",
        };
      } else if (selectedTab === "5") {
        const selectedRows = gridRefs.current["grid9"].current.focusedRowNode();
        return {
          cd_firm: userInfo.cd_firm,
          cd_fin: selectedRows.data?.cd_fin,
          tp_fin: "5",
        };
      } else if (selectedTab === "6") {
        const selectedRows =
          gridRefs.current["grid11"].current.focusedRowNode();
        return {
          cd_firm: userInfo.cd_firm,
          cd_fin: selectedRows.data?.cd_fin,
          tp_fin: "6",
        };
      } else if (selectedTab === "7") {
        const selectedRows =
          gridRefs.current["grid13"].current.focusedRowNode();
        return {
          cd_firm: userInfo.cd_firm,
          cd_fin: selectedRows.data?.cd_fin,
          tp_fin: "7",
        };
      }
      return true;
    } catch (error) {
      return false;
    }
  };

  const onInsert = async () => {
    try {
      const cdfin = await calCdFin(selectedTab);
      if (selectedTab === "1") {
        const modifiedRowsH = gridRefs.current["grid1"].current.getChange();
        if (modifiedRowsH.modifiedRowcount > 0) {
          await showDialog("alter", "수정된 내용이 있습니다.");
          return;
        }
        const newRow = {
          cd_firm: userInfo.cd_firm,
          tp_fin: "1",
          cd_fin: cdfin,
        };
        gridRefs.current["grid1"].current?.addRow(newRow);
        await updateDataSource(selectedTab, gridRefs.current["grid2"].current);
      } else if (selectedTab === "2") {
        const modifiedRowsH = gridRefs.current["grid3"].current.getChange();
        if (modifiedRowsH.modifiedRowcount > 0) {
          await showDialog("alter", "수정된 내용이 있습니다.");
          return;
        }
        const newRow = {
          cd_firm: userInfo.cd_firm,
          tp_fin: "2",
          cd_fin: cdfin,
        };
        gridRefs.current["grid3"].current?.addRow(newRow);
        await updateDataSource(selectedTab, gridRefs.current["grid4"].current);
      } else if (selectedTab === "3") {
        const modifiedRowsH = gridRefs.current["grid5"].current.getChange();
        if (modifiedRowsH.modifiedRowcount > 0) {
          await showDialog("alter", "수정된 내용이 있습니다.");
          return;
        }
        const newRow = {
          cd_firm: userInfo.cd_firm,
          tp_fin: "3",
          cd_fin: cdfin,
        };
        gridRefs.current["grid5"].current?.addRow(newRow);
        await updateDataSource(selectedTab, gridRefs.current["grid6"].current);
      } else if (selectedTab === "4") {
        const modifiedRowsH = gridRefs.current["grid7"].current.getChange();
        if (modifiedRowsH.modifiedRowcount > 0) {
          await showDialog("alter", "수정된 내용이 있습니다.");
          return;
        }
        const newRow = {
          cd_firm: userInfo.cd_firm,
          tp_fin: "4",
          cd_fin: cdfin,
        };
        gridRefs.current["grid7"].current?.addRow(newRow);
        await updateDataSource(selectedTab, gridRefs.current["grid8"].current);
      } else if (selectedTab === "5") {
        const modifiedRowsH = gridRefs.current["grid9"].current.getChange();
        if (modifiedRowsH.modifiedRowcount > 0) {
          await showDialog("alter", "수정된 내용이 있습니다.");
          return;
        }
        const newRow = {
          cd_firm: userInfo.cd_firm,
          tp_fin: "5",
          cd_fin: cdfin,
        };
        gridRefs.current["grid9"].current?.addRow(newRow);
        await updateDataSource(selectedTab, gridRefs.current["grid10"].current);
      } else if (selectedTab === "6") {
        const modifiedRowsH = gridRefs.current["grid11"].current.getChange();
        if (modifiedRowsH.modifiedRowcount > 0) {
          await showDialog("alter", "수정된 내용이 있습니다.");
          return;
        }
        const newRow = {
          cd_firm: userInfo.cd_firm,
          tp_fin: "6",
          cd_fin: cdfin,
        };
        gridRefs.current["grid11"].current?.addRow(newRow);
        await updateDataSource(selectedTab, gridRefs.current["grid12"].current);
      } else if (selectedTab === "7") {
        const modifiedRowsH = gridRefs.current["grid13"].current.getChange();
        if (modifiedRowsH.modifiedRowcount > 0) {
          await showDialog("alter", "수정된 내용이 있습니다.");
          return;
        }
        const newRow = {
          cd_firm: userInfo.cd_firm,
          tp_fin: "7",
          cd_fin: cdfin,
        };
        gridRefs.current["grid13"].current?.addRow(newRow);
        await updateDataSource(selectedTab, gridRefs.current["grid14"].current);
      }
    } catch (error: any) {}
  };

  const calCdFin = async (tpfin: string): Promise<string> => {
    try {
      const params = {
        id: "sn_mas_set_reg_004_01",
        params: { cd_firm: userInfo.cd_firm, tp_fin: tpfin },
      };

      const data: any = await fnGetDataSet(params);

      if (!data || data.length === 0 || data[0].length === 0) return "001";

      let maxCdFin = Number(data[0][0]["cd_fin"]) || 0;

      data[0].forEach((result: any) => {
        const cdFin = Number(result.cd_fin) || 0;
        if (maxCdFin <= cdFin) maxCdFin = cdFin + 1;
      });

      const str = maxCdFin.toString().padStart(3, "0");
      return str;
    } catch (error) {
      return "";
    }
  };

  const onDelete = async () => {
    const confirm = await showDialog("confirm", "삭제하시겠습니까?");

    if (!confirm) {
      return;
    }
    let realDeletedRows: any[] = [];
    switch (selectedTab) {
      case "1":
        gridRefs.current["grid2"].current?.deleteAllRows();
        gridRefs.current["grid1"].current?.deleteSelectedRows();

        realDeletedRows =
          gridRefs.current["grid1"].current.getChange().delete ?? [];
        if (Array.isArray(realDeletedRows) && realDeletedRows.length < 1) {
          gridRefs.current["grid1"].current.resetUpdate();
          gridRefs.current["grid2"].current.resetUpdate();
          return;
        }
        break;

      case "2":
        gridRefs.current["grid4"].current?.deleteAllRows();
        gridRefs.current["grid3"].current?.deleteSelectedRows();
        realDeletedRows =
          gridRefs.current["grid3"].current.getChange().delete ?? [];
        if (Array.isArray(realDeletedRows) && realDeletedRows.length < 1) {
          gridRefs.current["grid3"].current.resetUpdate();
          gridRefs.current["grid4"].current.resetUpdate();
          return;
        }
        break;

      case "3":
        gridRefs.current["grid6"].current?.deleteAllRows();
        gridRefs.current["grid5"].current?.deleteSelectedRows();
        realDeletedRows =
          gridRefs.current["grid5"].current.getChange().delete ?? [];
        if (Array.isArray(realDeletedRows) && realDeletedRows.length < 1) {
          gridRefs.current["grid5"].current.resetUpdate();
          gridRefs.current["grid6"].current.resetUpdate();
          return;
        }
        break;

      case "4":
        gridRefs.current["grid8"].current?.deleteAllRows();
        gridRefs.current["grid7"].current?.deleteSelectedRows();
        realDeletedRows =
          gridRefs.current["grid7"].current.getChange().delete ?? [];
        if (Array.isArray(realDeletedRows) && realDeletedRows.length < 1) {
          gridRefs.current["grid7"].current.resetUpdate();
          gridRefs.current["grid8"].current.resetUpdate();
          return;
        }
        break;

      case "5":
        gridRefs.current["grid10"].current?.deleteAllRows();
        gridRefs.current["grid9"].current?.deleteSelectedRows();
        realDeletedRows =
          gridRefs.current["grid9"].current.getChange().delete ?? [];
        if (Array.isArray(realDeletedRows) && realDeletedRows.length < 1) {
          gridRefs.current["grid9"].current.resetUpdate();
          gridRefs.current["grid10"].current.resetUpdate();
          return;
        }
        break;

      case "6":
        gridRefs.current["grid12"].current?.deleteAllRows();
        gridRefs.current["grid11"].current?.deleteSelectedRows();
        realDeletedRows =
          gridRefs.current["grid11"].current.getChange().delete ?? [];
        if (Array.isArray(realDeletedRows) && realDeletedRows.length < 1) {
          gridRefs.current["grid11"].current.resetUpdate();
          gridRefs.current["grid12"].current.resetUpdate();
          return;
        }
        break;

      case "7":
        gridRefs.current["grid14"].current?.deleteAllRows();
        gridRefs.current["grid13"].current?.deleteSelectedRows();
        realDeletedRows =
          gridRefs.current["grid13"].current.getChange().delete ?? [];
        if (Array.isArray(realDeletedRows) && realDeletedRows.length < 1) {
          gridRefs.current["grid13"].current.resetUpdate();
          gridRefs.current["grid14"].current.resetUpdate();
          return;
        }
        break;
    }

    return await onSave();
  };

  useImperativeHandle(ref, () => ({
    onSearch,
    onSave,
    onInsert,
    onDelete,
  }));

  //#region Event Method
  // const onFocusedRowChanged = (event: any) => {
  //   const selectedRow = event; // 클릭한 행 데이터
  //   if (selectedRow) {
  //     const tp_fin = selectedRow.tp_fin;
  //     const cd_fin = selectedRow.cd_fin;
  //     switch (selectedTab) {
  //       case "1":
  //         gridRef2.current.applyFilters({ cd_fin: cd_fin, tp_fin: tp_fin });
  //         gridRef2.current.selectAndFocusRow(0);
  //         break;

  //       case "2":
  //         gridRef4.current.applyFilters({ cd_fin: cd_fin, tp_fin: tp_fin });
  //         gridRef4.current.selectAndFocusRow(0);
  //         break;

  //       case "3":
  //         gridRef6.current.applyFilters({ cd_fin: cd_fin, tp_fin: tp_fin });
  //         gridRef6.current.selectAndFocusRow(0);
  //         break;

  //       case "4":
  //         gridRef8.current.applyFilters({ cd_fin: cd_fin, tp_fin: tp_fin });
  //         gridRef8.current.selectAndFocusRow(0);
  //         break;

  //       case "5":
  //         gridRef10.current.applyFilters({ cd_fin: cd_fin, tp_fin: tp_fin });
  //         gridRef10.current.selectAndFocusRow(0);
  //         break;

  //       case "6":
  //         gridRef12.current.applyFilters({ cd_fin: cd_fin, tp_fin: tp_fin });
  //         gridRef12.current.selectAndFocusRow(0);
  //         break;

  //       case "7":
  //         gridRef14.current.applyFilters({ cd_fin: cd_fin, tp_fin: tp_fin });
  //         gridRef14.current.selectAndFocusRow(0);
  //         break;
  //     }
  //   } else {
  //     return;
  //   }
  // };
  //#endregion

  const onTabChange = async (index: string) => {
    if (!index) return;
    setSelectedTab(index);
    await onSearch(index);
  };

  const onGridBtnClick = async (id: string) => {
    if (id == "btnAdd") {
      // 라인은 헤더에 종속되므로 선택된 비용형태(cd_fin) 아래로만 붙인다.
      const header: any = onBeforeAddRowL();
      if (!header || typeof header !== "object" || !header.cd_fin) {
        await showDialog("alter", "비용형태를 먼저 선택해 주세요.");
        return;
      }

      try {
        const result = await callApi("SN_MAS_SET_REG_004_btnAdd", {
          cd_firm: userInfo.cd_firm,
          cd_fin: header.cd_fin,
        });
        // 완료/실패 안내창은 callApi가 백엔드 message로 띄운다.
        if (result?.status) await onSearch();
      } catch (error: any) {
      }
    }
    if (id == "btnErp") {
    }
  };

  const grids = useMemo(
    () => ({
      grid1: {
        columns: columns.grid1,
        dataSource: dataSources.grid1,
      },
      grid2: {
        columns: columns.grid2,
        dataSource: dataSources.grid2,
        events: { onBeforeAddRow: onBeforeAddRowL },
      },
      grid3: {
        columns: columns.grid3,
        dataSource: dataSources.grid3,
      },
      grid4: {
        columns: columns.grid4,
        dataSource: dataSources.grid4,
        events: { onBeforeAddRow: onBeforeAddRowL },
      },
      grid5: {
        columns: columns.grid5,
        dataSource: dataSources.grid5,
      },
      grid6: {
        columns: columns.grid6,
        dataSource: dataSources.grid6,
        events: { onBeforeAddRow: onBeforeAddRowL },
      },
      grid7: {
        columns: columns.grid7,
        dataSource: dataSources.grid7,
      },
      grid8: {
        columns: columns.grid8,
        dataSource: dataSources.grid8,
        events: { onBeforeAddRow: onBeforeAddRowL },
      },
      grid9: {
        columns: columns.grid9,
        dataSource: dataSources.grid9,
      },
      grid10: {
        columns: columns.grid10,
        dataSource: dataSources.grid10,
        events: { onBeforeAddRow: onBeforeAddRowL },
      },
      grid11: {
        columns: columns.grid11,
        dataSource: dataSources.grid11,
      },
      grid12: {
        columns: columns.grid12,
        dataSource: dataSources.grid12,
        events: { onBeforeAddRow: onBeforeAddRowL },
      },
      grid13: {
        columns: columns.grid13,
        dataSource: dataSources.grid13,
      },
      grid14: {
        columns: columns.grid14,
        dataSource: dataSources.grid14,
        events: { onBeforeAddRow: onBeforeAddRowL },
      },
    }),
    [columns, dataSources]
  );

  return (
    <div className="h-full flex flex-col w-full">
      <SnTab
        titles={[
          "매출",
          "수금",
          "매입",
          "수입비용",
          "외주",
          "기타비용",
          "사업장이동",
        ]}
        header={[
          <SnTabHeader
            body={
              <div>
                <SnButton
                  text={"ERP 연동"}
                  onClick={() => {
                    onGridBtnClick("btnErp");
                  }}
                />
              </div>
            }
          />,
          <SnTabHeader
            body={
              <div>
                <SnButton
                  text={"ERP 연동"}
                  onClick={() => {
                    onGridBtnClick("btnErp");
                  }}
                />
              </div>
            }
          />,
          <SnTabHeader
            body={
              <div>
                <SnButton
                  text={"ERP 연동"}
                  onClick={() => {
                    onGridBtnClick("btnErp");
                  }}
                />
              </div>
            }
          />,
          <SnTabHeader
            body={
              <div>
                <SnButton
                  text={"ERP 연동"}
                  onClick={() => {
                    onGridBtnClick("btnErp");
                  }}
                />
              </div>
            }
          />,
          <SnTabHeader
            body={
              <div>
                <SnButton
                  text={"ERP 연동"}
                  onClick={() => {
                    onGridBtnClick("btnErp");
                  }}
                />
              </div>
            }
          />,
          <SnTabHeader
            body={
              <div>
                <SnButton
                  text={"추가사항 적용"}
                  onClick={() => {
                    onGridBtnClick("btnAdd");
                  }}
                />
                <SnButton
                  text={"ERP 연동"}
                  onClick={() => {
                    onGridBtnClick("btnErp");
                  }}
                />
              </div>
            }
          />,
          <SnTabHeader
            body={
              <div>
                <SnButton
                  text={"ERP 연동"}
                  onClick={() => {
                    onGridBtnClick("btnErp");
                  }}
                />
              </div>
            }
          />,
        ]}
        width="100%"
        onTabChanged={onTabChange}
        body={[
          <div className="w-full flex h-full min-h-0 space-x-1.5">
            <SnResizable
              direction={"width"}
              seq={1}
              cd_menu={cd_menu}
              defaultSize={defaultSize}
              size={sizes.panelTab1}
              onResizeStop={onResizeStop}
              enable={{ right: true }}
              minWidth={280}
            >
              <SnGrid
                ref={gridRefs.current["grid1"]}
                columnConfig={grids.grid1.columns}
                rowData={grids.grid1.dataSource}
                etcProps={{ rowSelection: "single" }}
                filter={{
                  refs: [gridRefs.current["grid2"]],
                  columns: ["cd_fin", "tp_fin"],
                }}
              />
            </SnResizable>
            <div className="flex-1 h-full min-h-0 min-w-0">
              <SnGrid
                ref={gridRefs.current["grid2"]}
                columnConfig={grids.grid2.columns}
                rowData={grids.grid2.dataSource}
                etcProps={{ rowSelection: "single" }}
                events={grids.grid2.events}
              />
            </div>
          </div>,

          <div className="w-full flex h-full min-h-0 space-x-1.5">
            <SnResizable
              direction={"width"}
              seq={2}
              cd_menu={cd_menu}
              defaultSize={defaultSize}
              size={sizes.panelTab2}
              onResizeStop={onResizeStop}
              enable={{ right: true }}
              minWidth={280}
            >
              <SnGrid
                ref={gridRefs.current["grid3"]}
                columnConfig={grids.grid3.columns}
                rowData={grids.grid3.dataSource}
                etcProps={{ rowSelection: "single" }}
                filter={{
                  refs: [gridRefs.current["grid4"]],
                  columns: ["cd_fin", "tp_fin"],
                }}
              />
            </SnResizable>
            <div className="flex-1 h-full min-h-0 min-w-0">
              <SnGrid
                ref={gridRefs.current["grid4"]}
                columnConfig={grids.grid4.columns}
                rowData={grids.grid4.dataSource}
                etcProps={{ rowSelection: "single" }}
                events={grids.grid4.events}
              />
            </div>
          </div>,
          <div className="w-full flex h-full min-h-0 space-x-1.5">
            <SnResizable
              direction={"width"}
              seq={3}
              cd_menu={cd_menu}
              defaultSize={defaultSize}
              size={sizes.panelTab3}
              onResizeStop={onResizeStop}
              enable={{ right: true }}
              minWidth={280}
            >
              <SnGrid
                ref={gridRefs.current["grid5"]}
                columnConfig={grids.grid5.columns}
                rowData={grids.grid5.dataSource}
                etcProps={{ rowSelection: "single" }}
                filter={{
                  refs: [gridRefs.current["grid6"]],
                  columns: ["cd_fin", "tp_fin"],
                }}
              />
            </SnResizable>
            <div className="flex-1 h-full min-h-0 min-w-0">
              <SnGrid
                ref={gridRefs.current["grid6"]}
                columnConfig={grids.grid6.columns}
                rowData={grids.grid6.dataSource}
                etcProps={{ rowSelection: "single" }}
                events={grids.grid6.events}
              />
            </div>
          </div>,
          <div className="w-full flex h-full min-h-0 space-x-1.5">
            <SnResizable
              direction={"width"}
              seq={4}
              cd_menu={cd_menu}
              defaultSize={defaultSize}
              size={sizes.panelTab4}
              onResizeStop={onResizeStop}
              enable={{ right: true }}
              minWidth={280}
            >
              <SnGrid
                ref={gridRefs.current["grid7"]}
                columnConfig={grids.grid7.columns}
                rowData={grids.grid7.dataSource}
                etcProps={{ rowSelection: "single" }}
                filter={{
                  refs: [gridRefs.current["grid8"]],
                  columns: ["cd_fin", "tp_fin"],
                }}
              />
            </SnResizable>
            <div className="flex-1 h-full min-h-0 min-w-0">
              <SnGrid
                ref={gridRefs.current["grid8"]}
                columnConfig={grids.grid8.columns}
                rowData={grids.grid8.dataSource}
                etcProps={{ rowSelection: "single" }}
                events={grids.grid8.events}
              />
            </div>
          </div>,
          <div className="w-full flex h-full min-h-0 space-x-1.5">
            <SnResizable
              direction={"width"}
              seq={5}
              cd_menu={cd_menu}
              defaultSize={defaultSize}
              size={sizes.panelTab5}
              onResizeStop={onResizeStop}
              enable={{ right: true }}
              minWidth={280}
            >
              <SnGrid
                ref={gridRefs.current["grid9"]}
                columnConfig={grids.grid9.columns}
                rowData={grids.grid9.dataSource}
                etcProps={{ rowSelection: "single" }}
                filter={{
                  refs: [gridRefs.current["grid10"]],
                  columns: ["cd_fin", "tp_fin"],
                }}
              />
            </SnResizable>
            <div className="flex-1 h-full min-h-0 min-w-0">
              <SnGrid
                ref={gridRefs.current["grid10"]}
                columnConfig={grids.grid10.columns}
                rowData={grids.grid10.dataSource}
                etcProps={{ rowSelection: "single" }}
                events={grids.grid10.events}
              />
            </div>
          </div>,
          <div className="w-full flex h-full min-h-0 space-x-1.5">
            <SnResizable
              direction={"width"}
              seq={6}
              cd_menu={cd_menu}
              defaultSize={defaultSize}
              size={sizes.panelTab6}
              onResizeStop={onResizeStop}
              enable={{ right: true }}
              minWidth={280}
            >
              <SnGrid
                ref={gridRefs.current["grid11"]}
                columnConfig={grids.grid11.columns}
                rowData={grids.grid11.dataSource}
                etcProps={{ rowSelection: "single" }}
                filter={{
                  refs: [gridRefs.current["grid12"]],
                  columns: ["cd_fin", "tp_fin"],
                }}
              />
            </SnResizable>
            <div className="flex-1 h-full min-h-0 min-w-0">
              <SnGrid
                ref={gridRefs.current["grid12"]}
                columnConfig={grids.grid12.columns}
                rowData={grids.grid12.dataSource}
                etcProps={{ rowSelection: "single" }}
                events={grids.grid12.events}
              />
            </div>
          </div>,

          <div className="w-full flex h-full min-h-0 space-x-1.5">
            <SnResizable
              direction={"width"}
              seq={7}
              cd_menu={cd_menu}
              defaultSize={defaultSize}
              size={sizes.panelTab7}
              onResizeStop={onResizeStop}
              enable={{ right: true }}
              minWidth={280}
            >
              <SnGrid
                ref={gridRefs.current["grid13"]}
                columnConfig={grids.grid13.columns}
                rowData={grids.grid13.dataSource}
                etcProps={{ rowSelection: "single" }}
                filter={{
                  refs: [gridRefs.current["grid14"]],
                  columns: ["cd_fin", "tp_fin"],
                }}
              />
            </SnResizable>
            <div className="flex-1 h-full min-h-0 min-w-0">
              <SnGrid
                ref={gridRefs.current["grid14"]}
                columnConfig={grids.grid14.columns}
                rowData={grids.grid14.dataSource}
                etcProps={{ rowSelection: "single" }}
                events={grids.grid14.events}
              />
            </div>
          </div>,
        ]}
      />
    </div>
  );
});

export default SN_MAS_SET_REG_004;
